import "./EntityUpdate.scss";
import React, { useEffect, useState } from "react";
import { Table, Tag, Modal, Form, Input, Button } from "antd";
import { timestampToTimeSince } from "../../Utilities";
import ENVIRONMENT from "../../../../environments";
import axios from "axios";
import _ from "lodash";
import JobDetails from "./JobDetails";

const LOGS_URL = ENVIRONMENT.JOB_LOGS_URL;

const FailedAndAbortedJobs = () => {
  const [loading, setLoading] = useState(false);
  const [jobData, setJobData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const getColumns = () => [
    {
      title: "Request ID",
      dataIndex: "request_id",
      key: "request_id",
      sorter: (a, b) => a.request_id - b.request_id,
    },
    {
      title: "Entity ID",
      dataIndex: "entity_id",
      key: "entity_id",
      render: (text, record) => <a href={getEntityUrlFromEntityType(record.entity_type,text)} target="_blank" rel="noopener noreferrer">{text}</a>
    },
    {
      title: "Entity Type",
      dataIndex: "entity_type",
      key: "entity_type",
    },
    {
      title: "Job Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Customer Username",
      dataIndex: "customer_username",
      key: "customer_username",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => 
        <Tag color={text === "failed" ? "red" : "blue"}>
          {text.charAt(0).toUpperCase() + text.slice(1)}
        </Tag>
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      key: "end_time",
      render: (text) => timestampToTimeSince(text),
    },
    {
      title: "Action",  
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => handleAction(record)}>
          Regenerate Job
        </Button>
      ),
    }
  ];
  
  useEffect(() => {
    loadFailedAndAbortedJobs();
  }, []);

  const handleAction = (record) => {
    setSelectedJob(record);
    setModalOpen(true);
  };

  const getEntityUrlFromEntityType = (entityType, entityId) => {
    if (entityType === "scene") {
      return `/admin_scene_render/${entityId}`;
    } else if (entityType === "product") {
      return `/admin_products/${entityId}`;
    } else if (entityType === "room") {
      return `/admin_rooms/${entityId}`;
    } else if (entityType === "material") {
      return `/admin_materials/${entityId}`;
    } 
    return "";
  };

  const loadFailedAndAbortedJobs = async () => {
    setLoading(true);
    try {
      const [failedResponse, abortedResponse] = await Promise.all([
        axios.post(ENVIRONMENT.AUTOMATION_REQUEST_GET_BATCH, {
          request_status: 'failed',
        }),
        axios.post(ENVIRONMENT.AUTOMATION_REQUEST_GET_BATCH, {
          request_status: 'aborted',
        })
      ]);
      
      const combinedData = [...failedResponse.data, ...abortedResponse.data];
      const filteredData = filterInternalUsers(combinedData);
      setJobData(filteredData);
    } catch (error) {
      console.error('Error loading jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterInternalUsers = (data) => {
    const internalUsers = ["CA1", "CA2", "meharfatimakhan", "CA2 (Tintash1)", "CA1 (Tintash1)", "faizan42 (Tintash1)", "Seerat (Tintash1)"];
    return data.filter(job => !internalUsers.includes(job.customer_username));
    return data
  };

  return (
    <div>
        <Table columns={getColumns()} dataSource={jobData} loading={loading} />
        <JobDetails modalOpen = {modalOpen} setModalOpen = {setModalOpen} selectedJob = {selectedJob} />
    </div>
  );
};

export default FailedAndAbortedJobs;